import { render } from "./Study_Profile.vue?vue&type=template&id=53e2ab9a&scoped=true"
import script from "./Study_Profile.js?vue&type=script&lang=js"
export * from "./Study_Profile.js?vue&type=script&lang=js"

import "./Study_Profile.vue?vue&type=style&index=0&id=53e2ab9a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e2ab9a"]])

export default __exports__